import React, { useContext } from "react";
import { string } from "prop-types";
import { Col } from "react-bootstrap";
import * as i18n from "util/i18n";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import TransactionStatus from "pages/transactions/_components/TransactionStatus";

export const TransactionHeader = ({ status, subTitle }) => {
    const { transaction } = useContext(TransactionContext);
    const { idTransactionStatus = status } = transaction;

    return (
        <Col xs={12} md={8} mdOffset={2} lg={6} lgOffset={3}>
            <div className="media-object  column ">
                <figure>
                    <TransactionStatus iconFidelity="ticket" idTransactionStatus={idTransactionStatus} />
                </figure>
                <div className="media-object--text">
                    <h5>
                        {i18n.get(
                            subTitle || `forms.transaction.ticket.status.${idTransactionStatus}.firstTitle.checkbook`,
                        )}
                    </h5>
                </div>
            </div>
        </Col>
    );
};

TransactionHeader.propTypes = {
    status: string,
    subTitle: string,
};

TransactionHeader.defaultProps = {
    status: "",
    subTitle: "",
};

export default TransactionHeader;
